// Homepage app-feature accordion (includes/app-feature-accordion.jsp): opening a card plays its
// looping, muted app video. Desktop gets the square cut, tablet the horizontal one, phone none.
function initAppAccordion(accordion) {
  const desktopQuery = window.matchMedia('(min-width: 1025px)');
  const phoneQuery = window.matchMedia('(max-width: 749px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const items = [...accordion.querySelectorAll('.app-accordion__item')];
  const videos = [...accordion.querySelectorAll('.app-accordion__video')];
  let activeIndex = items.findIndex(item => item.classList.contains('is-open'));
  let isInView = false;

  // Which cut each video currently has loaded.
  const loadedCuts = new WeakMap();

  // Points the video at the cut for the current viewport.
  function loadVideo(video) {
    const cut = desktopQuery.matches ? 'Square' : 'Horizontal';
    if (loadedCuts.get(video) === cut) return;

    loadedCuts.set(video, cut);
    // Reduced motion never plays, so fetch just enough to show the first frame as a still.
    if (reducedMotionQuery.matches) {
      video.setAttribute('preload', 'metadata');
    }
    video.setAttribute('src', video.dataset[`src${cut}`]);
  }

  // Plays only the open card's video, and only while the section is on screen.
  function syncPlayback() {
    videos.forEach((video, index) => {
      if (index === activeIndex && isInView && !phoneQuery.matches) {
        loadVideo(video);
        if (!reducedMotionQuery.matches) {
          // Autoplay can still be refused (e.g. iOS Low Power Mode); the video just stays paused.
          video.play().catch(() => {});
        }
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  function setOpen(index, isOpen) {
    const trigger = items[index].querySelector('.app-accordion__trigger');
    items[index].classList.toggle('is-open', isOpen);
    videos[index].classList.toggle('is-active', isOpen);
    trigger.setAttribute('aria-expanded', isOpen);
    // One card is always open, so its button can't collapse it (WAI-ARIA accordion pattern).
    if (isOpen) {
      trigger.setAttribute('aria-disabled', 'true');
    } else {
      trigger.removeAttribute('aria-disabled');
    }
  }

  function openItem(index) {
    if (index === activeIndex) return;

    setOpen(activeIndex, false);
    setOpen(index, true);
    activeIndex = index;
    videos[index].currentTime = 0;
    syncPlayback();
  }

  items.forEach((item, index) => {
    item.querySelector('.app-accordion__trigger').addEventListener('click', () => openItem(index));
  });

  const observer = new window.IntersectionObserver(([entry]) => {
    isInView = entry.intersectionRatio >= 0.25;
    syncPlayback();
  }, { threshold: 0.25 });
  observer.observe(accordion);

  desktopQuery.addEventListener('change', syncPlayback);
  phoneQuery.addEventListener('change', syncPlayback);
}

const appAccordion = document.getElementById('appAccordion');
if (appAccordion) {
  initAppAccordion(appAccordion);
}
